import { Column, CreateDateColumn, Entity, UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn } from "typeorm";

@Entity('defect')
export class Defect {
    @PrimaryGeneratedColumn("increment", { name: 'defect_id' })
    defectId: number;

    @Column("char", {
        nullable: false,
        length: 50,
        name: "defect_name"
    })
    defectName: string;

    @Column("boolean", {
        name: "is_active",
        default: true,
        nullable: false
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    updateAt: Date;

    @Column("varchar", {
        nullable: false,
        default: 1,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    createdAt: Date;
}